/*
 * @Author: Teemo Ding
 * @Date: 2021-07-21 09:41:42
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-08-26 13:35:19
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelPayment/AvailablePaymentGateways/index.tsx
 */

import Table from '@/src/components/Antd/Table/SizeFittingTable';
import Configuration from '@/src/components/Configuration/Configuration';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Button, Form } from 'antd';
import React from 'react';
import { availableColumns } from '../config';
import css from '../css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const AvailablePaymentGateways = ({
  paymentGatewaysList,
  handleSelectPaymentGateway,
  deleteFun,
  editFun,
  isMini,
  disableEdit,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      // containerClassName={css.invoiceFormat}
      title={getI18n('salesChannelPayment.index.availablePaymentGateways')}>
      <Form.Item
        noStyle
        shouldUpdate={(p, c) =>
          p.enableProcessingFee !== c.enableProcessingFee
        }>
        {({ getFieldValue }) => (
          <Table
            id='availablePaymentGateways'
            rowKey='uuid'
            className={css.globalStoreTable}
            columns={availableColumns(
              deleteFun,
              editFun,
              isMini,
              getFieldValue('enableProcessingFee') && isMini,
              disableEdit,
              { getI18n },
            )}
            dataSource={paymentGatewaysList}
            pagination={false}
          />
        )}
      </Form.Item>
      {!(isMini && paymentGatewaysList.length === 1) && (
        <Button
          type='primary'
          disabled={disableEdit}
          onClick={() => handleSelectPaymentGateway()}
          className={css.selectedBtn}>
          {getI18n('salesChannelPayment.index.selectPaymentGateway')}
        </Button>
      )}
      <Configuration
        configStart={getI18n('salesChannelPayment.index.gotoStoreSettings')}
        linkTo={`/settings/payment/list`}
        configLink={getI18n('salesChannelPayment.index.payment')}
        configEnd={getI18n(
          'salesChannelPayment.index.tomanagepaymentgatewayssettings',
        )}
      />
    </SectionWrapper>
  );
};

export default AvailablePaymentGateways;
